<template>
  <RfStatusEnabled v-if="isActive && !isCompleted" />
  <RfStatusPaused v-else-if="!isActive && !isCompleted" />
  <RfStatusDisabled v-else-if="!isActive && isCompleted" />
  <span v-else></span>
</template>

<script setup>
import RfStatusDisabled from "@/components/statuses/RfStatusDisabled.vue";
import RfStatusEnabled from "@/components/statuses/RfStatusEnabled.vue";
import RfStatusPaused from "@/components/statuses/RfStatusPaused.vue";

defineProps({
  isActive: { type: Boolean, default: false },
  isCompleted: { type: Boolean, default: true },
});
</script>
